module.exports = __webpack_public_path__ + "static/media/AthletesLaunch_Logo.c97cc016.png";